module.exports = __webpack_public_path__ + "static/media/nr.635d72d4.svg";